<div class="mp-header">
	<div class="mp-toolbar mp-toolbar--danger" style="text-align: center;">
		<span class="mp-label ion-text-wrap" style="font-weight: 800; font-size: 16px;" translate text-wrap><strong translate>Away for too long</strong></span>
	</div>
</div>

<div class="mp-content">
	<div class="text-center my-2" style="font-size: 20px; width: 100%;">
		<mp-icon name="time-outline" style="font-size: 30vh;"></mp-icon>
		<br>
		<span translate>It looks like you've been idle for a long time...</span>
		<br><br>
		<span translate>Please reload the page.</span>
	</div>

	<button class="mp-button mp-button--ios mp-button--block mp-button--danger" (click)="reloadPage()" translate>Reload</button>
</div>
